import { BasePresenter } from "core/presenter";

export default class ReportEmail extends BasePresenter {
  async onSend(email) {
    if (this.isValidEmail(email)) {
      this.props.onSendEmailReport(email);
    } else {
      this.sendNotification({
        type: "warning",
        content: "Esse email é inválido. Verifique se digitou corretamente."
      });
    }
  }

  isValidEmail(email) {
    const emailRegex = /^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i;
    return emailRegex.test(email);
  }
}



// WEBPACK FOOTER //
// ./src/components/app/management/payments-report/report-email/presenter.js